import { AuthGuard } from '@adminprodigydesign/axis';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { adminDashboardData } from '../../../waitron-admin/public/dummy/admin-data';
import { ActivateAccountComponent } from './core/layouts/activate-account/activate-account.component';
import { WaitronAdminShellLayoutComponent } from './core/layouts/waitron-admin-shell-layout/waitron-admin-shell-layout.component';
import { TenantResolver } from './tenant-resolver';

// Admin components (copied from your old routes)
// To be imported into admin app.

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    loadChildren: () => import('./core/core.module').then((m) => m.CoreModule),
  },
  {
    path: '',
    component: WaitronAdminShellLayoutComponent,
    data: adminDashboardData,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    resolve: { tenant: TenantResolver },
    children: [
      {
        path: 'dashboard',
        redirectTo: '/live-orders',
        pathMatch: 'full',
      },
      {
        path: 'reports',
        loadChildren: () =>
          import('./features/reports/reports.module').then(
            (m) => m.ReportsModule,
          ),
      },
      {
        path: 'setup',
        loadChildren: () =>
          import('./features/setup/setup.module').then((m) => m.SetupModule),
      },
      // {
      //   path: 'marketing',
      //   loadChildren: () =>
      //     import('./features/marketing/marketing.module').then(
      //       (m) => m.MarketingModule,
      //     ),
      // },
      {
        path: 'live-orders',
        loadChildren: () =>
          import('./features/live-orders/live-orders.module').then(
            (m) => m.LiveOrdersModule,
          ),
      },
      {
        path: 'support',
        loadChildren: () =>
          import('./features/support/support.module').then(
            (m) => m.SupportModule,
          ),
      },
    ],
  },
  { path: 'authentication-withPassword', component: ActivateAccountComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
